<template lang="pug">
.View.View--MerchantHome.fill-height
  template(v-if="!loading")
    .fill-height.d-flex.flex-column.pa-6
      .Top
        img.d-block.mx-auto.mb-3(src="/merchant/home/ipratico.png")
        img.d-block.mx-auto(src="/merchant/home/openlist.png")
      .Middle.flex-grow-1.d-flex.align-center.justify-center.flex-column
        .headline.white--text.text-center Incrementa il tuo flusso di lavoro con OpenList
        .mt-3
          v-btn.white--text(
            small,
            outlined,
            href="https://www.ipratico.com/suite/openlist-merchant.php",
            target="_blank"
          ) Scopri di più
      .Bottom.d-flex.flex-column
        .text-center.mb-6
          v-btn.primary.px-6(rounded, text, :to="{ name: 'auth.login' }") Login
        .text-center
          v-btn.white--text(text, :to="{ name: 'auth.register' }") Crea un account
  template(v-else)
    Loading
</template>

<script>
import HelpAlert from "@/components/HelpAlert";
import Loading from "@/components/Loading";

export default {
  name: "Home",
  components: { HelpAlert, Loading },
  data() {
    return {
      loading: true
    };
  },
  created() {
    if (this.$auth.check()) {
      return this.$router.replace({ name: "company.location.list" });
    }

    this.$emit("update:title", "OpenList Business");
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 250);
  }
};
</script>

<style lang="scss">
.View--MerchantHome {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(/merchant/home/background.png);
  background-size: cover;
  background-attachment: fixed;
  background-position: center;

  @media screen and (min-width: 600px) {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
      url(/merchant/home/background-desktop.jpg);
    background-size: cover;
    background-attachment: fixed;
    background-position: center;
  }
}
</style>
